import React, { useState } from 'react';
import Button from '@jbhi-fi/lanyard-ui/components/Button';
import { Arrow } from '@jbhi-fi/lanyard-ui/components/Icons';
import LocationIcon from '@jbhi-fi/lanyard-ui/components/Icons/Location';
import { styles } from './CustomerCollectInformation.css';
import { StoreInformationType } from '@jbhi-fi/apis/src/orderTrackingThemeApi/types';

type StoreInformationProps = {
  store: StoreInformationType;
  onDirectionSearch: (storeName: string) => void;
};

export const StoreInformation = ({ store, onDirectionSearch }: StoreInformationProps) => {
  const [shouldShowFullOpeningHours, setShouldShowFullOpeningHours] = useState(false);

  const getStoreOpeningHours = () => {
    return store.openingHours
      .slice(0, shouldShowFullOpeningHours ? undefined : 2)
      .map((openingHour: string, index: number) => {
        if (openingHour.includes('Open today')) {
          return (
            <div role="paragraph" key={index}>
              <span className={styles.todayText}>Open today</span>
              <span>{openingHour.slice('Open today'.length)}</span>
            </div>
          );
        }
        return (
          <div role={'paragraph'} key={index}>
            {openingHour}
          </div>
        );
      });
  };
  return (
    <>
      {store.directionsLink ? (
        <div>
          <Button
            type="linkWithIcon"
            icon={<LocationIcon />}
            iconPosition="left"
            onClick={() => onDirectionSearch(store.name)}
            label={'Get directions'}
          />
        </div>
      ) : null}
      <div>
        <div role={'paragraph'} className={styles.openingHours}>
          Opening hours
        </div>
        {getStoreOpeningHours()}
        <Button
          classes={styles.showMoreButton}
          type="linkWithIcon"
          icon={<Arrow className={styles.showMoreIcon({ shouldShowMore: shouldShowFullOpeningHours })} />}
          label={shouldShowFullOpeningHours ? 'Show less' : 'Show all'}
          iconPosition="left"
          onClick={() => setShouldShowFullOpeningHours(!shouldShowFullOpeningHours)}
        />
      </div>
    </>
  );
};
